// auth
export const SET_AUTH_USER = 'SET_AUTH_USER'
export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_USER_CLAIMS = 'SET_USER_CLAIMS'

// events
export const SET_EVENTS = 'SET_EVENTS'
export const SET_EVENTS_LOADING = 'SET_EVENTS_LOADING'

// notifications
export const SET_NOTIFICATION = 'SET_NOTIFICATION'
export const SET_PROMPT = 'SET_PROMPT'

// language
export const SET_CURRENT_LANGUAGE = 'SET_CURRENT_LANGUAGE'
export const SET_CURRENT_LOCALE = 'SET_CURRENT_LOCALE'

// contact
export const SET_CONTACT_MODAL = 'SET_CONTACT_MODAL'

// news
export const SET_NEWS = 'SET_NEWS'
export const SET_NEWS_CATEGORIES = 'SET_NEWS_CATEGORIES'
export const SET_NEWS_LOADING = 'SET_NEWS_LOADING'
export const SET_MORE_NEWS_AVAILABLE = 'SET_MORE_NEWS_AVAILABLE'

// statistics
export const SET_STATISTICS = 'SET_STATISTICS'
